<template>
     <div class="table">
        <div class="container" style="float:right;width:95%;">
            <div style="display: inline-block; height:40px;">
                <el-select v-model="queryForm.deptId" placeholder="请选择学校">
                    <el-option
                        v-for="item in depts"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div style="display: inline-block; height:40px;"> 
                <el-input v-model="queryForm.name" placeholder="维度/类别名称" style="width: 150px;" ></el-input>  
            </div>
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="getData()">查询</el-button>
            </div>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="primary" plain @click="setAddDimension">添加维度</el-button>
                <el-button type="danger"  @click="setCopy()">复制</el-button>
            </div>

            <el-table
                :data="dataList"
                v-loading="loading"
                :element-loading-text = "loadingText"
                element-loading-background = "rgba(255, 255,255,0.7)"
                row-key="id"
                border>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="text" label="维度/类别名称"></el-table-column>
                <el-table-column fixed="right" label="操作" width="140px">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setAddType(scope.row)"
                           v-if="scope.row.parentId == '0' " 
                           type="text"
                            size="small">
                            <span style="color: #387EE8;">新增类别</span>
                        </el-button>
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button  @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 添加弹出框 -->
        <add-dimension v-model="addDimensionVisible" :deptId="queryForm.deptId" :parentId="form.id" :dimension="selectDimension" />
        <!-- 修改弹出框 -->
        <update-dimension v-model="updateDimensionVisible" :dimension="selectDimension" />
        <!-- 复制弹出框 -->
        <set-Copy v-model="setCopyVisible" :currSchoolId="queryForm.deptId" />
    </div>
</template>

<script>
    import http from '../../../common/http';
    import addDimension from './components/addDimension.vue';
    import updateDimension from './components/updateDimension.vue';
    import setCopy from './components/setCopy.vue';

    export default {
        name:"setDimension",
        data(){
            return{
                loading: false,
                loadingText: "",
                addDimensionVisible:false,
                updateDimensionVisible:false,
                setCopyVisible:false,
                queryForm:{
                    deptId: "",
                    name: ''
                },
                form:{
                    id:""
                },
                depts:[],
                dataList:[],
                // 选中的维度/类别
                selectDimension:{}
            }
        },
        components: {
            addDimension, updateDimension, setCopy
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.queryForm.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中...";

                let url  = this.clockinDimensionTreeListUrl;
                let data = {
                    deptId:this.queryForm.deptId,
                    name:this.queryForm.name,
                };
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res));
                    if(res.status == 200){
                       this.dataList = res.data.clockinDimensions;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            //添加维度
            setAddDimension(){
                this.form.id = ""
                this.selectDimension = null
                this.addDimensionVisible = true
            },
            //添加类别
            setAddType(data){
                this.form.id = data.id
                this.selectDimension = data
                this.addDimensionVisible = true
            },
            //修改界面
            setUpdate(data){
                this.form.id = data.id
                this.selectDimension = data
                this.updateDimensionVisible = true
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                this.loading=true;
                this.loadingText="数据删除中...";

                let url = this.clockinDimensionRemoveUrl;
                let data = {
                    'id': this.form.id
                };
                // console.log('delSuccess',data)
                // return
                this.apiPost(url,data).then((res)=>{
                    this.loading=false;
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                })
            },
            setCopy(){
                this.setCopyVisible = true
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/task/setDimension.vue